/*
* Custom JS
* Add custom javascript here!
*/

document.addEventListener('DOMContentLoaded', event => {
  // --- VT Free Shipping Progress Bar ---
  (function () {
    function formatMoney(cents) {
      if (window.Avatar && Avatar.theme && Avatar.theme.Currency && Avatar.theme.Currency.formatMoney) {
        return Avatar.theme.Currency.formatMoney(cents);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function updateBar(cart) {
      var bar = document.querySelector('[data-free-shipping-bar]');
      if (!bar) return;
      var threshold = parseInt(bar.getAttribute('data-free-shipping-threshold'), 10);
      if (!threshold) return;

      var message = bar.querySelector('[data-free-shipping-message]');
      var fill = bar.querySelector('[data-free-shipping-fill]');
      var remaining = threshold - cart.total_price;
      var percent = Math.min((cart.total_price / threshold) * 100, 100);

      if (fill) fill.style.width = percent + '%';
      if (message) {
        message.textContent = remaining <= 0
          ? "You've unlocked free shipping \u2014 before discount."
          : "You're " + formatMoney(remaining) + " away from free shipping \u2014 before discount.";
      }
      bar.classList.toggle('tw-hidden', cart.item_count === 0);
    }

    function refresh() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(updateBar)
        .catch(function () {});
    }

    refresh();

    var cartForm = document.querySelector('[data-slider-cart] form');
    if (cartForm) {
      var bar = document.querySelector('[data-free-shipping-bar]');
      var pending = null;
      var observer = new MutationObserver(function (mutations) {
        var relevant = mutations.some(function (m) {
          return !(bar && bar.contains(m.target));
        });
        if (!relevant) return;
        clearTimeout(pending);
        pending = setTimeout(refresh, 150);
      });
      observer.observe(cartForm, { childList: true, subtree: true, characterData: true });
    }
  })();
});

/** EVENTS
 * Product Form
 * document.addEventListener('product:form:loaded', (event) => {
 *   let variant = event.detail.variant; // Give you the default selected variant
 *   let formElement = event.target;
 *   console.log(variant, formElement)
 * });
 *
 *
 */